import React, { useState, useEffect } from 'react';

const VidaInstitucional = () => {
  const images = [
    '/galeria1.jpg',
    '/galeria2.jpg',
    '/galeria3.jpg',
    '/galeria4.jpg',
    '/galeria5.jpg',
    '/galeria6.jpg',
    '/galeria7.jpg',
    '/galeria8.jpg',
    '/galeria9.jpg',
    '/galeria10.jpg'
  ];

  const [modalOpen, setModalOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const openModal = (index) => {
    setActiveIndex(index);
    setModalOpen(true);
  };

  const closeModal = () => setModalOpen(false);
  const nextImage = () => setActiveIndex((prev) => (prev + 1) % images.length);
  const prevImage = () => setActiveIndex((prev) => (prev - 1 + images.length) % images.length);

  const scrollToGallery = () => {
    document.getElementById('galeria').scrollIntoView({ behavior: 'smooth' });
  };

  // Scroll automático al cargar hacia la sección de Vida Institucional
  useEffect(() => {
    const target = document.getElementById('vida-institucional');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  return (
    <div style={{ fontFamily: 'Montserrat, sans-serif' }}>

      {/* SECCIÓN VIDA INSTITUCIONAL */}
      <div
        id="vida-institucional"
        style={{
          backgroundColor: '#f9fafb',
          padding: '80px 40px',
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <div style={{
          maxWidth: '1100px',
          width: '500%',
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          gap: '20px'
        }}>
          <h2 style={{
            fontSize: '42px',
            fontWeight: 'bold',
            color: '#111827',
            flex: '1 1 100%',
            margin: '0 0 0 10px'
          }}>
            Vida Institucional
          </h2>

          <div style={{
            width: '300px',
            backgroundColor: '#fff',
            borderRadius: '5px',
            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            marginLeft: '700px'
          }}>
            <img
              src="/VidaI.png"
              alt="Vida Institucional"
              style={{
                width: '110%',
                height: '220px',
                objectFit: 'cover'
              }}
            />
            <div style={{ padding: '16px', flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
              <div>
                <h3 style={{
                  fontSize: '15px',
                  fontWeight: 'bold',
                  color: '#004170',
                  marginBottom: '10px'
                }}>
                  Preparatoria
                </h3>
                <p style={{
                  fontSize: '15px',
                  color: '#374151',
                  textAlign: 'justify',
                  lineHeight: '1.5',
                  marginBottom: '16px'
                }}>
                "Somos una institución privada comprometida con la excelencia académica, dedicada a la formación de profesionales capaces de interactuar con su entorno social, integrando conocimientos, valores y habilidades."
                </p>
              </div>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <button
                  onClick={scrollToGallery}
                  style={{
                    backgroundColor: '#001f3f',
                    color: '#fff',
                    border: 'none',
                    padding: '8px 20px',
                    borderRadius: '25px',
                    fontSize: '14px',
                    cursor: 'pointer'
                  }}
                >
                  Galería
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* SECCIÓN GALERÍA */}
      <div id="galeria" style={{
        backgroundColor: '#fff',
        padding: '60px 20px',
        margin: '0 auto',
        maxWidth: '100%',
      }}>
        <h3 style={{
          fontSize: '36px',
          fontWeight: 'bold',
          textAlign: 'center',
          marginBottom: '40px',
          color: '#0f2d45'
        }}>Galería</h3>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gridAutoRows: '240px',
          gap: '15px',
          padding: '0 5%',
        }}>
          {images.map((src, index) => (
            <div
              key={index}
              onClick={() => openModal(index)}
              style={{
                overflow: 'hidden',
                cursor: 'pointer',
                position: 'relative',
                borderRadius: '5px',
                transition: 'transform 0.3s ease',
                gridRow: index % 5 === 0 ? 'span 2' : 'span 1',
              }}
            >
              <img
                src={src}
                alt={`galeria-${index + 1}`}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  transition: 'transform 0.4s ease',
                }}
                onMouseOver={e => e.currentTarget.style.transform = 'scale(1.1)'}
                onMouseOut={e => e.currentTarget.style.transform = 'scale(1)'}
              />
            </div>
          ))}
        </div>
      </div>

      {/* MODAL DE GALERÍA */}
      {modalOpen && (
        <div style={{
          position: 'fixed',
          top: 0, left: 0, width: '100vw', height: '100vh',
          backgroundColor: 'rgba(0,0,0,0.85)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999,
        }}>
          <button onClick={closeModal} style={{
            position: 'absolute',
            top: '30px',
            right: '50px',
            fontSize: '25px',
            background: 'none',
            border: 'none',
            color: '#fff',
            cursor: 'pointer',
          }}>✖</button>

          <button onClick={prevImage} style={{
            position: 'absolute',
            left: '20px',
            top: '50%',
            transform: 'translateY(-50%)',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            border: 'none',
            borderRadius: '50%',
            fontSize: '18px',
            padding: '8px',
            cursor: 'pointer',
          }}>◀</button>

          <img src={images[activeIndex]} alt="Grande" style={{
            maxWidth: '90%',
            maxHeight: '80%',
            borderRadius: '10px',
            boxShadow: '0 4px 20px rgba(255,255,255,0.2)'
          }} />

          <button onClick={nextImage} style={{
            position: 'absolute',
            right: '20px',
            top: '50%',
            transform: 'translateY(-50%)',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            border: 'none',
            borderRadius: '50%',
            fontSize: '18px',
            padding: '8px',
            cursor: 'pointer',
          }}>▶</button>
        </div>
      )}
    </div>
  );
};

export default VidaInstitucional;
